import Lenis from '@studio-freight/lenis'
import globalVar from '../utils/globalVar'

class SmoothScroll {
  constructor() {
    if (!globalVar.desktop.matches) return

    this.lenis = new Lenis({
      duration: 2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      prevent: (node) => node.hasAttribute('data-lenis-prevent'),
    })

    this.raf = this.raf.bind(this)
    requestAnimationFrame(this.raf)
  }

  raf(time) {
    this.lenis.raf(time)
    requestAnimationFrame(this.raf)
  }

  // Pause/resume from other modules (e.g. module-11 scroll zone)
  lock()              { this.lenis?.stop() }
  unlock()            { this.lenis?.start() }
  scrollTo(t, opts)   { this.lenis?.scrollTo(t, opts) }
}

export { SmoothScroll }
